import styled from 'styled-components';

export const LoginContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
`;

export const LoginForm = styled.form.attrs({
  noValidate: true,
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  width: 100%;
  max-width: 420px;
`;

export const Input = styled.input`
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 5px;
  border: none;
  font-size: 9pt;
  background-color: var(--input-bg);
  color: var(--text-primary);
  outline: none;
  outline-style: none;
  border: none;
  border-bottom: solid var(--border-default) 1px;
  width: min(280px, 88vw) !important;
  font-style: italic;

  ::placeholder {
    color: var(--input-placeholder);
  }

  :hover {
    color: var(--text-primary);
    --font-size: 22px;
    font-weight: bold;
  }
`;

export const Button = styled.button`
  padding: 0.5rem;
  border-radius: 5px;
  border: none;
  background-color: var(--accent);
  color: var(--text-on-accent);
  font-size: 1rem;
  margin: 10px;
  cursor: pointer;
  width: 140px;
`;

export const Img = styled.img`
  width: min(90vw, 400px);
  max-width: 400px;
  height: auto;
  margin-bottom: clamp(1.5rem, 8vh, 75px);
`;

export const LoginButtonsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
  width: 100%;
  margin-top: 0.5rem;
`;

export const LoginWelcome = styled.h1`
  color: #ffffff;
  font-size: clamp(1.75rem, 8vw, 3rem);
  text-align: center;
  margin: 0 0 1rem;
  padding: 0 0.5rem;
`;

const buttonBase = `
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: rgba(0,128,0, .2) 0 -25px 18px -14px inset,rgba(0,128,0, .15) 0 1px 2px,rgba(0,128,0, .15) 0 2px 4px,rgba(0,128,0, .15) 0 4px 8px,rgba(0,128,0, .15) 0 8px 16px,rgba(0,128,0, .15) 0 16px 32px;
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 1.0px solid var(--border-strong);
  font-size: 14px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 0;
  width: 140px;
  max-width: 100%;
  height: 40px;

  :hover:not(:disabled) {
    box-shadow: rgba(0,128,0,.35) 0 -25px 18px -14px inset,rgba(0,128,0,.35) 0 1px 2px,rgba(0,128,0,.35) 0 2px 4px,rgba(0,128,0,.35) 0 4px 8px,rgba(0,128,0,.35) 0 8px 16px,rgba(0,128,0,.35) 0 16px 32px;
    transform: scale(1.02);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    width: min(140px, 42vw);
    font-size: 13px;
  }
`;

export const StyledButtonLogin = styled.button`${buttonBase}`;
export const StyledButtonCadastro = styled.button`${buttonBase}`;
export const StyledButtonEnviarEmail = styled.button`
  ${buttonBase}
  @media screen and (max-width: 768px) {
    width: min(180px, 70vw);
    font-size: 13px;
  }
`;
export const StyledButtonVoltar = styled.button`${buttonBase}`;

export const LoginDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: min(280px, 88vw);
  margin: 1rem 0 0.75rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.8rem;
  font-style: italic;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(255, 255, 255, 0.35);
  }
`;

export const GoogleLoginButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  width: min(280px, 88vw);
  height: 42px;
  padding: 0 1rem;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: #ffffff;
  color: #3c4043;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover:not(:disabled) {
    transform: scale(1.02);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
  }
`;

const loginFieldStyles = `
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 5px;
  font-size: 9pt;
  background-color: var(--input-bg);
  color: var(--text-primary);
  outline: none;
  outline-style: none;
  border: none;
  border-bottom: solid var(--border-default) 1px;
  width: min(280px, 88vw) !important;
  font-style: italic;
  box-sizing: border-box;

  ::placeholder {
    color: var(--input-placeholder);
  }

  :hover {
    color: var(--text-primary);
    font-weight: bold;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ShowInput = styled.input`
  ${loginFieldStyles}
`;

export const PasswordWrapper = styled.div`
  position: relative;
  width: min(280px, 88vw);
  margin-bottom: 1rem;
`;

export const PasswordInput = styled.input`
  ${loginFieldStyles}
  margin-bottom: 0;
  width: 100% !important;
  padding-right: 2rem;
`;

export const StyledShowPasswordButton = styled.button`
  position: absolute;
  right: 0.35rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.15rem;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    opacity: 0.85;
  }
`;
